import { useQuery } from "urql";

import {
  CollateralFilter,
  CollateralOrderBy,
  GetCollateralsDocument,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const useCollaterals = ({
  filter,
  orderBy,
  pause,
  page,
}: ApiHookProps<CollateralFilter, CollateralOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetCollateralsDocument, variables, pause });
};
